import { render, staticRenderFns } from "./TicketMessageAttachement.vue?vue&type=template&id=7abdcab4&scoped=true&"
import script from "./TicketMessageAttachement.vue?vue&type=script&lang=ts&"
export * from "./TicketMessageAttachement.vue?vue&type=script&lang=ts&"
import style0 from "./TicketMessageAttachement.vue?vue&type=style&index=0&id=7abdcab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abdcab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7abdcab4')) {
      api.createRecord('7abdcab4', component.options)
    } else {
      api.reload('7abdcab4', component.options)
    }
    module.hot.accept("./TicketMessageAttachement.vue?vue&type=template&id=7abdcab4&scoped=true&", function () {
      api.rerender('7abdcab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketMessageAttachement.vue"
export default component.exports